<template>
  <div class="bar"></div>
    <div class="spacer">
      <div class="container mx-0">
          <div class="row no-gutters">
            <div class="col-12 col-md-5">
              <h1 ref="title" class="display-4 position-relative fontSize45">
                Gestiona tus finanzas en cualquier momento y lugar
              </h1>
              <p ref="subtitle" class="lead position-relative">
                Consulta inventarios, genera facturas, y potencia tu estrategia de ventas en una plataforma diseñada para optimizar cada aspecto de tu negocio.
              </p>
              <!-- <button ref="btnIniciar" class="btn btn-primary btn-sm" @click="goToDemo">Iniciar gratis</button> -->
            </div>
          </div>
      </div>
    </div>
      <div id="cover">
        <div id="canva"></div>
        <div class="container mx-0"> 
        </div>  
          <img
          ref="logoGradient"
          class="logoGradient"
          :src="require(`@/assets/svg/logo-gradient.svg`)"
          alt="logo-gradient"
        />
        <img
          ref="logoOutline"
          class="logoOutline"
          :src="require(`@/assets/svg/logo-outline.svg`)"
          alt="logo-outline"
        />  
      </div>
    <About/>
    <PlansVe/>
    <!-- <Contadores/> -->
    <VideoPrincipal/>
    

    <!-- <StayHome/> -->
    <!-- <Footer></Footer> -->
   <div class="object" ></div>
</template>

<script>
// Libs
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import * as ScrollMagic from "scrollmagic";

// import P5 from "p5";

// Views
import About from "./sections/About";
// import Footer from "./sections/Footer"; 
import VideoPrincipal from "./sections/VideoPrincipal.vue";
import PlansVe from "./sections_ve/Planes.vue"
// import StayHome from "./sections/StayHome";

export default {
  name: "Home",
  components: {
    About,
    // Footer,
    PlansVe,
    // Contadores,
    // StayHome,
    VideoPrincipal
  },
  created() {
    // const sketch = s => {
    //   let w = window.innerWidth;
    //   let h = window.innerHeight;
    //   s.setup = () => {
    //     s.createCanvas(w, h, s.WEBGL);
    //     s.noStroke();
    //   };
    //   s.draw = () => {
    //     s.background(12, 28, 42);
    //     const dirY = (s.mouseY / s.height - 0.5) * 4;
    //     const dirX = (s.mouseX / s.width - 0.5) * 4;
    //     s.directionalLight(204, 204, 204, dirX, dirY, 2);
    //     s.push();
    //     s.ambientLight(245, 245, 245);
    //     s.ambientMaterial("#072146");
    //     s.rotateZ(s.frameCount * 0.0001);
    //     s.rotateX(s.frameCount * 0.0001);
    //     s.rotateY(s.frameCount * 0.0001);
    //     s.torus(w >= 768 ? 500 : 250, 10);
    //     s.pop();
    //     s.push();
    //     s.ambientLight(245, 245, 245);
    //     s.ambientMaterial("#072146");
    //     s.rotateZ(s.frameCount * 0.0001);
    //     s.rotateX(s.frameCount * 0.0001);
    //     s.rotateY(s.frameCount * 0.0001);
    //     s.torus(w >= 768 ? 700 : 400, 20);
    //     s.pop();
    //   };
    //   s.windowResized = () => {
    //     w = window.innerWidth;
    //     h = window.innerHeight;
    //     s.resizeCanvas(w, h);
    //   };
    // };
    // new P5(sketch, "canva");
  },
  mounted() {
    this.initAnimation();
  },
  methods: {
    initAnimation() {
      const title = this.$refs.title;
      const subtitle = this.$refs.subtitle;
      const btnIniciar = this.$refs.btnIniciar;
      const logo1 = this.$refs.logoGradient;
      const logo2 = this.$refs.logoOutline;

      gsap
        .timeline()
        .fromTo(
          [title, subtitle, btnIniciar,  logo2, logo1],
          { duration: 0, y: -50, opacity: 0 },
          { delay: 1, duration: 1, y: 0, opacity: 1, stagger: 0.3 },
          "cover"
        );

      const sectionAbout = document.getElementById("alliance");
      this.$scrollMagic.addScene(
        new ScrollMagic.Scene({
          triggerElement: "#alliance",
          triggerHook: 1,
          offset: 100
        }).setTween(
          gsap.timeline().fromTo(
            [
              sectionAbout.querySelector(".title"),
              sectionAbout.querySelector(".lead")
            ],
            { opacity: 0, scale: 1.2, y: 300 },
            {
              opacity: 1,
              duration: 2,
              scale: 1,
              y: 0,
              stagger: 0.4,
              ease: "expo.out"
            }
          )
        )
      );

      this.$scrollMagic.addScene(
        new ScrollMagic.Scene({
          triggerElement: "#alliance",
          triggerHook: 1,
          offset: 100
        }).setTween(gsap.timeline().to([logo1], { opacity: 0 }))
      );

      this.$scrollMagic.addScene(
        new ScrollMagic.Scene({
          triggerElement: "#modulos",
          triggerHook: 1,
          offset: 100
        }).setTween(
          gsap.timeline().to([logo1, title, subtitle, btnIniciar,  logo2], { opacity: 0 })
        )
      );

      const sectionModules = document.getElementById("modulos");
      this.$scrollMagic.addScene(
        new ScrollMagic.Scene({
          triggerElement: "#modulos",
          triggerHook: 1,
          offset: 100
        }).setTween(
          gsap.timeline().fromTo(
            [
              sectionModules.querySelector(".title"),
              sectionModules.querySelector(".modules").children
            ],
            { opacity: 0, scale: 1.2, y: 300 },
            {
              opacity: 1,
              duration: 2,
              scale: 1,
              y: 0,
              stagger: 0.4,
              ease: "expo.out"
            }
          )
        )
      );

      const sectionContadores = document.getElementById("contadores");
      this.$scrollMagic.addScene(
        new ScrollMagic.Scene({
          triggerElement: "#contadores",
          triggerHook: 1,
          offset: 100
        }).setTween(
          gsap.timeline().fromTo(
            // , sectionContadores.querySelectorAll("h1")
            [sectionContadores],
            { opacity: 0, scale: 1.2, y: 300 },
            {
              opacity: 1,
              duration: 2,
              scale: 1,
              y: 0,
              stagger: 0.4,
              ease: "expo.out"
            }
          )
        )
      );
    },

    goToDemo() {
      this.$router.push('/crear_cuenta')
    }

  }
};
</script>

<style scoped lang="scss">

  .fontSize45 {
    font-size: 47px
  }

</style>
